import VendorRoutes from "../features/vendors/routes/VendorListRoutes";
import UserRoutes from "../features/users/routes/UserRoutes";
import PaymentRoutes from "../features/payments/routes/PaymentRoutes";
import OperatorRoutes from "../features/operators/routes/OperatorRoutes";
import IssuanceRoutes from "../features/issuance/routes/IssuanceRoutes";
import MasterWalletRoutes from "../features/master-wallet/routes/MasterWalletRoutes";
import CoverRoutes from "../features/covers/routes/CoverRoutes";
// import BookingRoutes from "../features/booking/routes/BookingRoutes";
import WebsiteRoutes from "../features/website/routes/WebsiteRoutes";
import BulkMailRoutes from "../features/bulk-email/routes/BulkMailRoutes";
import UserWalletRoutes from "../features/user-wallet/routes/UserWallet";
import UserDetailRoutes from "../features/users/routes/UserDetailRoutes";
import OperatorDetailRoutes from "../features/operators/routes/OperatorDetailRoutes";
import CoverViewRoutes from "../features/cover-view/routes/CoverViewRoutes";
import SalesRoutes from "../features/sales/routes/SalesRoutes";
const appRoutes = [
  ...VendorRoutes,
  ...UserRoutes,
  ...PaymentRoutes,
  ...OperatorRoutes,
  ...IssuanceRoutes,
  ...MasterWalletRoutes,
  ...CoverRoutes,
  // ...BookingRoutes,
  ...WebsiteRoutes,
  ...BulkMailRoutes,
  ...UserWalletRoutes,
  ...UserDetailRoutes,
  ...OperatorDetailRoutes,
  ...CoverViewRoutes,
  ...SalesRoutes,
];

export default appRoutes;